var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"relative",staticClass:"relative w-full h-px -mt-px",attrs:{"aria-hidden":""}}),(!_vm.onlyInline)?_c('div',{ref:"absolute",staticClass:"absolute sr-only w-screen",attrs:{"aria-hidden":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }